import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as Sentry from "@sentry/react";
import App from "./App";

Sentry.init({
  dsn: "https://b7e1b2f7d3f1563447c28ea2628f0e29@o4509425706663936.ingest.us.sentry.io/4510569686171648",
  tracesSampleRate: 1.0, // reduce in

  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
